import {Injectable} from "@angular/core";
import { Route, UrlSegment } from "@angular/router";
import {select, Store} from "@ngrx/store";
import {AppState} from "../../../reducers/reducer";
import {map, Observable} from "rxjs";
import {getRoles} from "../../selectors/auth.selector";
import {AuthService} from "../../services/auth.service";

@Injectable()
export class CanLoadRoleGuard  {
  constructor(
    private store: Store<AppState>,
  ) { }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean>|Promise<boolean>|boolean {
    return this.store
      .pipe(
        select(getRoles),
        map(roles => {
          const requiredRoles = route.data?.roles as Array<string>;
          return AuthService.hasAllRoles(requiredRoles, roles);
        })
      );
  }
}
